import { render, staticRenderFns } from "./proxy-detail.vue?vue&type=template&id=1779d819&"
import script from "./proxy-detail.vue?vue&type=script&lang=js&"
export * from "./proxy-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports